import styled from "styled-components";
import { motion } from "framer-motion";
import { COLORS, getColorByService } from "../../../../styles";
import { ServiceName } from "../../../../constants";
import { getGrandChartWindowWidth } from "../../../../helpers/grandChart";
import { getGrandChartWindowHeight } from "../../../../helpers/grandChart/grandChart.helper";

interface GCW_ContainerProps {
	$service: ServiceName;
	$modulesCount: number;

	$coursesCount: number;
}

export const GCW_Container = styled(motion.div)<GCW_ContainerProps>`
	width: min(calc(100vw - 32px), ${({ $modulesCount }) => getGrandChartWindowWidth($modulesCount)});
	height: min(calc(100vh - 32px), ${({ $coursesCount }) => getGrandChartWindowHeight($coursesCount)});
	display: grid;
	grid-template-rows: 86px 1fr;
	gap: 20px;
	background: ${COLORS.Light_Gray};
	border-radius: 16px;
	box-shadow: 0 32px 100px rgba(0, 0, 0, 0.45);
	padding: 5px;
	overflow: auto;

	&::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.25);
		border-radius: 20px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.06);
		border-radius: 20px;
	}
`;

export const grandChartWindowVariants = {
	hidden: {
		opacity: 0,
		scale: 0.96,
		y: 18,
	},
	visible: {
		opacity: 1,
		scale: 1,
		y: 0,
		transition: {
			duration: 0.35,
			ease: [0.16, 1, 0.3, 1],
			when: "beforeChildren",
		},
	},
	exit: {
		opacity: 0,
		scale: 0.96,
		y: 18,
		transition: {
			duration: 0.2,
		},
	},
};
